export enum CalendarDateElement {
  From = "From",
  To = "To"
}
